import useApiManager from 'networking/ApiManager';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { add, editIconY, uploaded, eyeView } from 'res/images';
import { Modal, Button, ButtonToolbar, Placeholder } from 'rsuite';
import PrescriptionActivityCreate from 'whealth-core-web/forms/PrescriptionActivityCreate';
import CoreButton from './CoreButton';
import { profileImage, dateFormat, dayTime, timeFormat, teamRoles, scrollToTop, splitArrData } from './Helper';
import Loader from './Loader';
import './prescription.css';
import { Pagination, Select2DropDown, EmptyView } from 'whealth-core-web/components';
import CommonToolTip from './CommonToolTip';
import { useDispatch } from 'react-redux';
import { setAlerts, setMedicineActiveCard, setReduxpafData } from 'redux/Slices';
import parse from 'html-react-parser';
import { act } from 'react';
import { pdf } from '@react-pdf/renderer';
import OPDReportPDF from '../../whealth-core-web/components/PrescriptionPdf/Content'

function RenderPafTab(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { userData,newPAF, getPatientData } = props;
  const { id } = useParams();
  const ApiClient = useApiManager();
  const navigate = useNavigate();
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('alert-success');
  const [pafData, setpafData] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentList, setDepartmentList] = useState([]);
  const [pdfModal, setPdfModule] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [printItem, setprintItem] = useState({});
  const [activeDept, setActiveDept] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const is_super_admin = userData?.role == 'super_admin';

  const dispatch = useDispatch();

  useEffect(() => {
    getListData();
  }, [id, currentPage]);

  const closeModalPdf = (item) => {
    setPdfModule(!pdfModal);
  };
  const closeShowModal = (item) => {
    setShowModal(!showModal);
  };

  const openModalPdf = async (item) => {
    setprintItem(item);
  
    if (!pdfModal) {
      setIsLoading(true);
      try {
        const res = await ApiClient.prescriptionPdfDownload(id, item.id);
        let blob, blobURL;
  
        if (res.data) {
          // Assuming pdf() returns a Promise
          blob = await pdf(<OPDReportPDF data={res.data} />).toBlob();
          blobURL = URL.createObjectURL(blob);
        } else {
          blob = new Blob([res.data], { type: 'application/pdf' });
          blobURL = URL.createObjectURL(blob);
        }
  
        setPdfUrl(blobURL);
        setPdfModule(!pdfModal);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    }
  };
  // const openModalPdf = (item) => {
  //   setprintItem(item);
  //   if (!pdfModal) {
  //     setIsLoading(true);
  //     ApiClient.prescriptionPdfDownload(id, item.id)
  //       .then((res) => {
  //         setIsLoading(false);
  //         var blob = new Blob([res.data], { type: 'application/pdf' });

  //         var blobURL = URL.createObjectURL(blob);
  //         setPdfUrl(blobURL);
  //         setPdfModule(!pdfModal);
  //         setIsLoading(false);
  //       })
  //       .catch((err) => {
  //         setIsLoading(false);
  //         console.log(err);
  //       });
  //   }
  // };

  useEffect(() => {
    getDepartment();
  }, []);

  const getDepartment = () => {
    ApiClient.getDepartment()
      .then((res) => {
        setDepartmentList(res.data);
      })
      .catch((err) => {
        console.warn('getDepartment error', err);
      });
  };

  const getListData = (departmentID = selectedDepartment, page = currentPage) => {
    console.log('start')
    setIsLoading(true);
    let params = { page };
    params.patient_id = id;

    ApiClient.pafList(id, params)
      .then((res) => {
        setIsLoading(false);
        setTotalPages(res.headers['total-pages']);
        setpafData(res.data);
        scrollToTop();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const editPaf = (user_id,id) => {
    window.open(`/patient/${user_id}/paf/${id}`, '_blank');
  };

  const pafUpdateStatus = (itemId) => {
    setIsLoading(true);
    // seterror({});
    const data = {
      id: itemId
    };
    ApiClient.updatePafStatus(data)
      .then((res) => {
        setIsLoading(false);
        getListData();
        console.log(res);
        dispatch(setAlerts({ patient: { title: 'Paf Linked to next prescription successfully.', type: 'alert-success' } }));
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status == 500) {
          setIsShowAlert('Internal server error');
        } else {
          setIsShowAlert(err.response.data.message);
        }
        setAlertType('alert-danger');
        setIsShowAlert(err.response.data.detail || err.response.data.message);
        console.log(err);
      });
  };
  


  const renderPrescriptionList = () => {
    return (
      <>
        <div class='default-tab'>
          
          <div class='tab-content'>
            <div class='tab-pane fade show active' id='home' role='tabpanel'>
              <div class='p-t-15'>
                {/* content */}
                {pafData?.results && pafData.results.length > 0 ? (
                  pafData?.results.map((item, index) => {

                    const buttonsData = () => {
                      return (
                        <div className='headingMilestone d-flex justify-content-between'>
                          <div className='d-flex'>
                            <div>
                              <b>Created On &nbsp; &nbsp;</b>
                              {dateFormat(item.created_at)} · {timeFormat(item.created_at)}
                            </div>
                            <div className='d-block  ms-2 '>
                              {item.status == 1 ?
                              <span className={`badge bg-info  capitalize Linked To Prescription`}>Linked To Prescription</span>
                              : 
                              item.status == 2 ?
                              <span className={`badge bg-info  capitalize Linked To Prescription`}>Prescribed</span>
                              :
                              <span className={`badge bg-info  capitalize draft`}>Created</span>
                              }
                              
                            </div>
                          </div>
                          <div
                            className='memberShipDetails'
                            style={{ display: `${activeDept == -1 ? 'none' : 'flex'}`, flexDirection: 'row', alignItems: 'center' }}
                          >
                            <>
                              {item.status == 0 && (
                                <>
                                <div
                                  className='mb-1 ms-2 pointer'
                                  onClick={() => {
                                    let windoConfirm = window.confirm('Are you sure you want to Link to next prescription?');
                                    if (windoConfirm) {
                                      pafUpdateStatus(item.id);
                                    }
                                  }}
                                >
                                  <div className='pt-1'>
                                    <CommonToolTip placement={'top'} item={<span class='material-icons-outlined'>medical_information</span>} showValue={'Link to next prescription'} />
                                  </div>
                                </div>
                                <div className='mb-1 ms-2 pointer' onClick={() => {
                                    editPaf(item?.user,item?.id)
                                  }} >
                                  <CommonToolTip
                                    placement={'top'}
                                    item={
                                      <div className='pt-1'>
                                        <span className='material-icons-outlined' style={{ color: '#757575' }}>
                                          edit
                                        </span>
                                      </div>
                                    }
                                    showValue={'Edit'}
                                  />
                                </div>
                                </>
                              )}
                              
                            </>
                          </div>
                        </div>
                      );
                    };
                    return (
                      <div className='cardDataBorder' key={index}>
                      <div className='d-flex'>
                        <div className='w-100'>
                          <div className='cardMilestone'>
                          {!userData?.read_only && !['ee', 'ee_manager'].includes(userData?.role) && (
                            <>
                            {buttonsData()}
                            </>
                            
                          )}
                
                            {/* HEADER */}
                            <div className='d-flex mt-1 mb-3 justify-content-between align-items-center'>
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <h5 className='coachtext capitalize'>
                                    {item?.doctor_details?.full_name || 'Doctor'}
                                  </h5>
                                  <p className='zeefitness'>
                                    {item?.clinic_details?.name} · {item?.clinic_details?.city}
                                  </p>
                                </div>
                              </div>
                              
                              
                              {/* <div className='badge capitalize lightGrayBadge'>
                                Insurance {item?.paf?.insurance_type || 'N/A'}
                              </div> */}
                            </div>
                
                            {/* VITAL DETAILS */}
                            {item?.paf && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Vital Details - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      <li>Age : {item.paf.age}</li>
                                      <li>Gender : {item.paf.gender}</li>
                                      <li>BP : {item.paf.bp}</li>
                                      <li>BMI : {item.paf.bmi}</li>
                                      <li>Pulse : {item.paf.pulse}</li>
                                      <li>
                                        Height : {item.paf.height_feet}' {item.paf.height_inch}"
                                      </li>
                                      <li>Weight : {item.paf.weight} kg</li>
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}
                
                            {/* COMPLAINT NOTES */}
                            <div className='d-flex'>
                              <div className='w-100'>
                                <span className='semiBold capitalize'>Complaint notes - </span>
                                <pre className='zeefitness prefont_family'>
                                  {parse(item?.paf?.complaintsNotes || '')}
                                </pre>
                              </div>
                            </div>
                            <div className='d-flex'>
                              <div className='w-100'>
                                <span className='semiBold capitalize'>Primary Pain - </span>
                                <pre className='zeefitness prefont_family'>
                                  {parse(item?.primary_pain?.pain_site || '')} | Duration: {parse(item?.primary_pain?.duration || '')} |
                                  Pain Score: {(item?.primary_pain?.pain_score || '')}
                                </pre>
                              </div>
                            </div>
                
                            {/* SECONDARY PAIN */}
                            {Array.isArray(item?.complaint_site) && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Secondary Pain - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.complaint_site
                                        .filter(site => site.painScore)
                                        .map((site, i) => (
                                          <li key={i}>
                                            {site.name}
                                            {site.left && ' Left'}
                                            {site.right && ' Right'}
                                            {site.center && ' Center'} | Duration: {site.duration} |
                                            Pain Score: {site.painScore}
                                          </li>
                                        ))}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}
                
                            {/* HEALTH CONDITIONS */}
                            {Array.isArray(item?.health_conditions) && item.health_conditions.length > 0 && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Health Conditions - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.health_conditions.map((v, i) => (
                                        <li key={i}>{v}</li>
                                      ))}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* ONSET */}
                            {item?.onset && (item?.onset?.onsetType || item?.onset?.progressType || item?.onset?.progressSpeed) && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Onset - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.onset.onsetType && <li>Onset Type: {item.onset.onsetType}</li>}
                                      {item.onset.progressType && <li>Progress Type: {item.onset.progressType}</li>}
                                      {item.onset.progressSpeed && <li>Progress Speed: {item.onset.progressSpeed}</li>}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* RADIATION/REFERRAL */}
                            {item?.radiation_referral && (item?.radiation_referral?.radiation?.selected || item?.radiation_referral?.referral?.selected) && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Radiation/Referral - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.radiation_referral.radiation?.selected && (
                                        <li>Radiation{item.radiation_referral.radiation?.text ? `: ${item.radiation_referral.radiation.text}` : ''}</li>
                                      )}
                                      {item.radiation_referral.referral?.selected && (
                                        <li>Referral{item.radiation_referral.referral?.text ? `: ${item.radiation_referral.referral.text}` : ''}</li>
                                      )}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* CHARACTER DATA */}
                            {Array.isArray(item?.character_data) && item.character_data.length > 0 && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Character - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.character_data.map((v, i) => (
                                        <li key={i}>{v}</li>
                                      ))}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* ASSOCIATED COMPLAINTS */}
                            {Array.isArray(item?.associated_complaints) && item.associated_complaints.length > 0 && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Associated Complaints - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.associated_complaints.map((v, i) => (
                                        <li key={i}>{v}</li>
                                      ))}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* PAIN TRIGGERS & RELIEVERS */}
                            {item?.pain_factors && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Pain Triggers & Relievers - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {Object.entries(item.pain_factors)
                                        .filter(([key, value]) => 
                                          typeof value === 'object' && value.name && (value.relieving || value.aggravating)
                                        )
                                        .map(([key, factor], i) => (
                                          <li key={i}>
                                            {factor.name}: 
                                            {factor.relieving && ' -'}
                                            {factor.aggravating && ' +'}
                                          </li>
                                        ))}
                                      {Object.entries(item.pain_factors)
                                        .filter(([key, value]) => typeof value === 'string' && (value === '+' || value === '-'))
                                        .map(([key, value], i) => (
                                          <li key={`str-${i}`}>
                                            {key}: {value}
                                          </li>
                                        ))}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {item?.pain_factors_other && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Pain Factors Other - </span>
                                  <pre className='zeefitness prefont_family'>{item.pain_factors_other}</pre>
                                </div>
                              </div>
                            )}
                
                            {/* ALLERGIES */}
                            {item?.allergies && (item?.allergies?.none || item?.allergies?.multi?.length > 0 || item?.allergies?.otherText) && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Allergies - </span>
                                  <pre className='zeefitness prefont_family'>
                                    {item.allergies.none ? (
                                      <ul>
                                        <li>None</li>
                                      </ul>
                                    ) : (
                                      <ul>
                                        {item.allergies.multi?.map((v, i) => (
                                          <li key={i}>{v}</li>
                                        ))}
                                        {item.allergies.otherText && <li>Other: {item.allergies.otherText}</li>}
                                      </ul>
                                    )}
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* MEDICATION HISTORY */}
                            {item?.medication_history && (item?.medication_history?.steroids || item?.medication_history?.anticoagulants || item?.medication_history?.othersText) && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Medication History - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.medication_history.steroids && <li>Steroids: Yes</li>}
                                      {item.medication_history.anticoagulants && <li>Anticoagulants: Yes</li>}
                                      {item.medication_history.othersText && <li>Others: {item.medication_history.othersText}</li>}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* FAMILY HISTORY */}
                            {item?.family_history && (item?.family_history?.hasHistory || item?.family_history?.details) && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Family History - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.family_history.hasHistory && <li>Has History: {item.family_history.hasHistory}</li>}
                                      {item.family_history.details && <li>Details: {item.family_history.details}</li>}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}

                            {/* PAST TREATMENTS */}
                            {item?.past_treatments && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>Past Treatments - </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.past_treatments.none && <li>None</li>}
                                      {item.past_treatments.otc && <li>OTC: Yes</li>}
                                      {item.past_treatments.physio && <li>Physio: Yes</li>}
                                      {item.past_treatments.physician && <li>Physician: Yes</li>}
                                      {item.past_treatments.altTreatments && <li>Alternative Treatments: Yes</li>}
                                      {item.past_treatments.pms?.selected && (
                                        <li>PMS: {item.past_treatments.pms.option}</li>
                                      )}
                                      {item.past_treatments.surgeon?.selected && (
                                        <li>Surgeon: {item.past_treatments.surgeon.option}</li>
                                      )}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}
                
                            {/* PAST REPORTS */}
                            {Array.isArray(item?.past_reports) && (
                              <div className='d-flex'>
                                <div className='w-100'>
                                  <span className='semiBold capitalize'>
                                    Past Reports -
                                  </span>
                                  <pre className='zeefitness prefont_family'>
                                    <ul>
                                      {item.past_reports.map((v, i) => (
                                        <li key={i}>{v}</li>
                                      ))}
                                    </ul>
                                  </pre>
                                </div>
                              </div>
                            )}
                
                            {/* OTHER DETAILS */}
                            <div className='d-flex'>
                              <div className='w-100'>
                                <span className='semiBold capitalize'>Other Details - </span>
                                <pre className='zeefitness prefont_family'>
                                  <ul>
                                    <li>City : {item?.paf?.city}</li>
                                    <li>Occupation : {item?.paf?.occupation}</li>
                                    <li>Activity Level : {item?.paf?.activityLevel}</li>
                                    <li>Insurance Category : {item?.paf?.insurance_category}</li>
                                    <li>Insurance : {item?.paf?.insurance_type}</li>
                                    {item?.paf?.contact_window && item.paf.contact_window.length > 0 && (
                                      <li>Contact Window : {item.paf.contact_window.join(', ')}</li>
                                    )}
                                    {item?.paf?.habits && item.paf.habits.length > 0 && (
                                      <li>Habits : {item.paf.habits.join(', ')}</li>
                                    )}
                                  </ul>
                                </pre>
                              </div>
                            </div>
                
                          </div>
                        </div>
                      </div>
                    </div>
                    );
                    
                  })
                ) : (
                  <EmptyView />
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className='d-flex justify-content-between'>
        <div className='pt-3 mb-3'>
        {!userData?.read_only && !['ee', 'ee_manager'].includes(userData?.role) && (
          <button type='button' className='btn mt-3 btn-outline-primary' onClick={newPAF}>
            <img src={add} className='icon' /> Initiate PAF
          </button>
        )}
        </div>
       
      </div>

      {renderPrescriptionList()}

      

      {/* PDF Modal */}
      
      <Loader show={isLoading} />
      <div className='d-flex justify-content-end'>
        <div className='patientPagination mt-3'>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </>
  );
}

export default RenderPafTab;
